import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { InviteContactsRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { InviteContactsResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const inviteContacts = (request: InviteContactsRequest, options?: CashRequestOptions) =>
  post<InviteContactsRequest, InviteContactsResponse>('/2.0/cash/invite-contacts', request, {
    ...options,
    rejectOnError: true,
  })
